import { useEffect, useState } from "react";
import { IconButton } from "@/components/Button";

import s from "./ClipboardButton.module.scss";

export function ClipboardButton() {
	const [showTooltip, setShowTooltip] = useState(false);

	useEffect(() => {
		if (showTooltip) {
			setTimeout(() => {
				setShowTooltip(false);
			}, 1000);
		}
	}, [showTooltip]);

	const handleClipboard = () => {
		var promise = navigator.clipboard.writeText(location.href);

		promise.then(() => {
			setShowTooltip(true);
		});
	};

	return (
		<div className={s.container}>
			{showTooltip && <div className={s.tooltip}>Gekopieerd naar klembord</div>}
			<IconButton icon="link" label="Kopieer link" onClick={handleClipboard} />
		</div>
	);
}
